import React from 'react'

const BackArrow = (props) => {
    const {className,style,onClick}=props;

  return (
    <div className={className} style={{...style, display: "block", background: "black"}} onClick={onClick}>
    </div>
  )
}

export default BackArrow